import { render, staticRenderFns } from "./GuidesList.vue?vue&type=template&id=63ddcace&scoped=true"
import script from "./GuidesList.vue?vue&type=script&lang=js"
export * from "./GuidesList.vue?vue&type=script&lang=js"
import style0 from "./GuidesList.vue?vue&type=style&index=0&id=63ddcace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ddcace",
  null
  
)

export default component.exports